const projects = [
  {
    title: "Pokemonline",
    description: "Gen 1 Pokemon MMORPG powered by WebGL and socket.io",
    href: "https://github.com/lrminer/pokemonline",
  },
  {
    title: "Daily Translator",
    description:
      "Full Catholic Bible with Spanish translations using swiping gestures. Pulls up a new chapter of bible each day.",
    href: "https://github.com/lrminer/daily-translator",
  },
];
export default projects;
